import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import DisclaimerContent from './DisclaimerContent';

export default function DisclaimerPage() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 pt-24 pb-16 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-2">
            {isZh ? '免责声明' : 'Disclaimer'}
          </h1>
          <p className="text-[#0A2540]/50 text-sm mb-8">
            {isZh ? '最后更新：2026年5月' : 'Last updated: May 2026'}
          </p>
          <DisclaimerContent />
        </div>
      </main>
      <Footer />
    </div>
  );
}
